import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";

import { useUIStateStore } from "@/store/uiStateStore";

function DateRangePicker({
  id,
  dateRange,
  setDateRange,
  isClearable = true,
  minDate = null,
  maxDate = null,
}) {
  const [startDate, endDate] = dateRange;
  const { t } = useTranslation();

  const isTunecore = useUIStateStore(state => state.isTunecore);

  return (
    <DatePicker
      id={id}
      selectsRange
      dateFormatCalendar=" "
      showMonthDropdown
      showYearDropdown
      showPopperArrow={false}
      dropdownMode="select"
      useShortMonthInDropdown
      startDate={startDate}
      endDate={endDate}
      minDate={minDate}
      maxDate={maxDate}
      onChange={(update) => {
        setDateRange(update);
      }}
      placeholderText={t("other:date-placeholder")}
      isClearable={isClearable}
      dateFormat="yyyy-MM-dd"
      className={`${isTunecore ? "text-white bg-tunecore-dark-element font-semibold border-1 border-white" : "border font-sentric-alt"} text-xs mr-10 w-full p-2 rounded-lg`}
    />
  );
}

export default DateRangePicker;
